import { render } from "./ConfirmDialog.vue?vue&type=template&id=71e7bd47"
import script from "./ConfirmDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmDialog.vue?vue&type=script&lang=js"
script.render = render

export default script